import queryClient from '@/utils/reactQueryClient';
import type {CampaignCreatorCounts} from '@/views/campaigns/creators-tab/types/creatorTabTypes';
import {CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY} from '@/hooks/queries/use-campaign-v2-creators-counts-query';

function updateCreatorCounts(
  campaignId: string | undefined,
  brandId: string | undefined,
  adjustment: Partial<CampaignCreatorCounts>
) {
  queryClient.setQueriesData<{data: CampaignCreatorCounts}>(
    {
      queryKey: [
        CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY,
        {campaignId, brandId},
      ],
    },
    (old) => {
      if (!old?.data) return old;
      return {
        ...old,
        data: {
          ...old.data,
          applications: old.data.applications + (adjustment.applications ?? 0),
          hired: old.data.hired + (adjustment.hired ?? 0),
          declined: old.data.declined + (adjustment.declined ?? 0),
          invited: (old.data.invited ?? 0) + (adjustment.invited ?? 0),
        },
      };
    }
  );
}

export default updateCreatorCounts;
